/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Submitted_TitleInputs */



/**
* | output |
* | --- |
* | "Job Submitted Successfully" |
*
* @param {Embed_Captions_Submitted_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_submitted_title = /** @type {((inputs?: Embed_Captions_Submitted_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Submitted_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tache soumise avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auftrag erfolgreich übermittelt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lavoro inviato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заявка успешно отправлена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Trabajo enviado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("职位提交成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ジョブが正常に送信されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्य सफलतापूर्वक सबमिट हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Trabalho submetido com sucesso.")
	return /** @type {LocalizedString} */ ("Job Submitted Successfully")
});